import { createAction } from 'redux-actions';

export const RESPONSIVE_SET_DEVICE = 'RESPONSIVE_SET_DEVICE';

/**
 * Sets the device type guessed from the request's user agent (server only).
 * Payload: `{ phone, tablet, mobile }` booleans, see detectDevice.
 */
export const setDevice = createAction(RESPONSIVE_SET_DEVICE);
